import React from 'react';
import { I18n } from 'aws-amplify';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom'

import FillForm from '../page-templates/fillForm';

import ExpertiseForm from './expertise-form';

import Steps from './steps';

const mapStateToProps = state => {
    return state;
};

const mapDispatchToProps = dispatch => {
    return {
    };
};

class LeaderSignupStep2 extends React.Component {
    constructor(props) {

        super();
        this.state = {
        };
    }

    scrollToTop() {
        const scrollDuration = 600;
        const scrollHeight = window.scrollY;
        const scrollStep = Math.PI / (scrollDuration / 15);
        const cosParameter = scrollHeight / 2;
        let scrollCount = 0;
        let scrollMargin;
        let scrollInterval = setInterval(() => {
            if (window.scrollY !== 0) {
                scrollCount = scrollCount + 1;  
                scrollMargin = cosParameter - cosParameter * Math.cos(scrollCount * scrollStep);
                window.scrollTo(0, (scrollHeight - scrollMargin));
            } else {
                clearInterval(scrollInterval); 
            }
        }, 15);
    }
    
    render() {

        return (
            <FillForm>
                <div className="hero-body has-background-white">
                    <div className="container">
                        <div className="columns is-mobile">
                            <div className="column is-4">
                                <span className="title-box">{I18n.get("Líderes")}</span>
                            </div>
                            <div className="column is-8">
                                <Steps active={2}/>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="leader-step leader-step-2">

                    <div className="container">

                        <div className="column is-8 is-offset-2">

                            <h1 className="title">
                                <span>2.</span>{I18n.get("Segmentos & Expertises")}</h1>

                            <ExpertiseForm {...this.props} />

                            <br />

                            <div className="field is-grouped is-grouped-centered">
                                <p className="control is-expanded">
                                    <Link to="/lider/passo-1" className="button is-black is-outlined is-fullwidth previous">{I18n.get("Voltar")}</Link>
                                </p>
                                <p className="control is-expanded"  onClick={this.scrollToTop}>
                                    <Link to="/lider/passo-3" className="button next is-black is-fullwidth">{I18n.get("PRÓXIMO [ 3 de 3 ]")}</Link>
                                </p>
                            </div>

                            <br /><br /><br /><br /><br /><br /><br /><br /><br />
                            <br /><br /><br /><br /><br /><br /><br /><br /><br />

                        </div>
                    </div>
            </div>


         </FillForm>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(LeaderSignupStep2);
